import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PreviousQualificationEvents from './PreviousQualificationEvents';
import QualifiedGolfersPreview from './QualifiedGolfersPreview';

function QualifiedGolfers({ isEventsShown }) {
    return (
        <div className="qualified-golfers" aria-live="polite">
            {isEventsShown ? <PreviousQualificationEvents/> : <QualifiedGolfersPreview/>}
        </div>
    );
}

QualifiedGolfers.propTypes = {
    isEventsShown: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    const { isEventsShown } = state;
    return { isEventsShown };
};

export default connect(mapStateToProps)(QualifiedGolfers);
